import React from 'react'
import { View, StyleSheet } from 'react-native'

import { DS } from '@/design-system'

import { formatChipsNumber } from '@/components/GameAssets/Player/PlayerBox'

import * as cth from '@/router/(root)/cth/cthModule'
import * as d10 from '@/router/(root)/daily10/d10Module'
import * as pocketPick from '@/router/(root)/pocketPick/pocketPickModule'

import { defaultTheme } from '@/components/Mini/theme'

function CthStatBlocks(){

  const { stats } = cth.useCthQueryHistory()
  const roundCount = cth.useStore(s => s.ROUND_COUNT)

  const theme = cth.useStore(s => s.theme)

  const data = [
    {"label": "Streak", "value": `${stats?.currentStreak ?? 0}`},
    {"label": "Best", "value": `${stats?.bestScore ?? 0}/${roundCount}`},
    {"label": "Played", "value": `${stats?.gamesPlayed ?? 0}`}
  ]

  return (
    <StatBlocks theme={theme} data={data}/>
  )

}    

function D10StatBlocks(){

  const { stats } = d10.useD10QueryHistory()

  const theme = d10.useStore(s => s.theme)

  const data = [
    {"label": "Streak", "value": `${stats?.currentStreak ?? 0}`}, //
    //{"label": "Best", "value": `${stats?.bestChips ?? 0}/${roundCount}`},
    {"label": "Best", "value": `${formatChipsNumber(stats?.bestChips ?? 0)}`},
    {"label": "Played", "value": `${stats?.timesPlayed ?? 0}`}
  ]

  return (
    <StatBlocks theme={theme} data={data}/>
  )

} 

function PocketPickStatBlocks(){

  const { stats } = pocketPick.usePocketPickQueryHistory()
  const roundCount = pocketPick.useStore(s => s.ROUND_COUNT)

  const theme = pocketPick.useStore(s => s.theme)

  const data = [
    {"label": "Streak", "value": `${stats?.currentStreak ?? 0}`},
    {"label": "Best", "value": `${stats?.bestScore ?? 0}/${roundCount}`},
    {"label": "Played", "value": `${stats?.gamesPlayed ?? 0}`}
  ]

  return (
    <StatBlocks theme={theme} data={data}/>
  )

}

type StatItem = { label: string; value: string }

  function StatBlocks({ theme=defaultTheme, data }: { theme?: typeof defaultTheme; data: StatItem[] }) {

  return (
    <View style={styles.statsRow}>
      {data.map(function (d, i){
        return <StatBlock key={"stat"+i} theme={theme} label={d.label} value={d.value} />
      })}
    </View>
  )

}

function StatBlock({ theme, label, value }: { theme: typeof defaultTheme; label: string; value: string }) {
  
  const borderColor = theme.surfaceBorder
  const backgroundColor = theme.surface
  const valueTextColor = theme.accent
  const labelTextColor = theme.textDefault

  return (
    <View style={[styles.stat, {borderColor, backgroundColor}]}>
      <DS.Text variant="Heading 2/Medium" style={{color: valueTextColor}}>
        {value}
      </DS.Text>
      <DS.Text variant="Caption/Regular" style={[styles.statLabel, {color: labelTextColor}]}>
        {label}
      </DS.Text>
  </View>
  )

}



const styles = StyleSheet.create({
  statsRow: { flexDirection: 'row', gap: 12 },
  stat: {
    flex: 1,
    alignItems: 'center',
    paddingVertical: 16,
    borderRadius: 16,
    borderWidth: 1,
  },
  statLabel: { marginTop: 4 },
})

export { StatBlocks, CthStatBlocks, D10StatBlocks, PocketPickStatBlocks }
